import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import axios from 'axios'

import Login from '@/pages/Login'
import Dashboard from '@/pages/Dashboard'
import AddCase from '@/pages/AddCase'
import NotFound from '@/pages/NotFound'
import RequestsHistory from '@/pages/RequestsHistory'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    component: Login,
    name: 'login'
  },
  {
    path: '/dashboard',
    component: Dashboard,
    name: 'dashboard',
    props: true
  },
  {
    path: '/add-case',
    component: AddCase,
    name: 'add-case'
  },
  {
    path: '/history/:flightId',
    component: RequestsHistory,
    name: 'requests-history'
  },
  {
    path: '/404',
    component: NotFound,
    name: 'not-found'
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  // Set language
  const lang = to.query.language
  const availableLanguages = ['pl', 'en', 'cs']
  const isLogged = localStorage.getItem('Token') != null

  if (availableLanguages.includes(lang)) {
    store.commit('setLanguage', lang)
  }

  if (isLogged) {
    axios.defaults.headers.common['Authorization'] =
      'Bearer ' + JSON.parse(localStorage.getItem('Token'))
    to.name === 'login' ? next({ name: 'dashboard' }) : next()
  } else {
    to.name === 'login' ? next() : next({ name: 'login' })
  }
})

export default router
